import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { singlePatient, singlePatientId1, patientsOfProvider } from '__mocks__/mockData/patients-data';

const PatientsDataApi = [
  rest.get(`${API_ROOT}patients/1`, (req, res, ctx) => {
    const userId = req.url.searchParams.get('userId');
    const additionalData = req.url.searchParams.get('additionalData');
    if (userId === '1' && additionalData === 'true') {
      return res(ctx.json(singlePatient));
    }
    return res(ctx.json({}));
  }),
  rest.put(`${API_ROOT}patients/1`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.get(`${API_ROOT}patients`, (req, res, ctx) => {
    const providerId = req.url.searchParams.get('providerId');
    const organizationId = req.url.searchParams.get('organizationId');
    if (providerId === '41' || organizationId) {
      return res(ctx.json(patientsOfProvider));
    }
    return res(ctx.json({}));
  }),
  rest.get(`${API_ROOT}patients/200`, (req, res, ctx) => res(ctx.json(singlePatient))),
  rest.get(`${API_ROOT}patients/patient_id1`, (req, res, ctx) => res(ctx.json(singlePatientId1))),
  rest.get(`${API_ROOT}patients/${singlePatient.id}`, (req, res, ctx) => {
    const type = req.url.searchParams.get('type');
    if (type === 'LOAD_PATIENT') {
      return res(ctx.json(singlePatient));
    }
    return res(ctx.json({}));
  }),
  rest.post(`${API_ROOT}patients`, (req, res, ctx) =>
    res(
      ctx.json({
        id: 1951,
        userId: 2501,
      }),
    ),
  ),
  rest.put(`${API_ROOT}patients/200`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.patch(`${API_ROOT}patients/200`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.patch(`${API_ROOT}patients/1`, (req, res, ctx) => res(ctx.json({ success: true }))),
];
export default PatientsDataApi;
